import { render, staticRenderFns } from "./BlockProperties.vue?vue&type=template&id=11156f04"
import script from "./BlockProperties.vue?vue&type=script&lang=js"
export * from "./BlockProperties.vue?vue&type=script&lang=js"
import style0 from "./BlockProperties.vue?vue&type=style&index=0&id=11156f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports